<template>
<li class="chat-item">
    <div class="message">
        <img v-on:click="openPersonCard(person)" v-bind:src="pictureUrl" class="askerIcon">
        <div class="message-span">
            <div class="message-user-name">
                <a v-if="person" v-on:click="openPersonCard(person)">{{person.firstName}} {{person.lastName}}</a>
            </div>
            <div class="message-text">{{question.question}}</div>
        </div>
        <div class="message-bottom-menu">
            <span class="message-timestamp">{{getTimestamp}}</span>
            <span class="message-reply-button" v-on:click="viewReplies()">{{$t('str.Reply')}}</span>
            <span v-if="question.props !== null" class="message-comments" v-on:click="toggleReplies()">
                {{$tc('str.CommentsCount', isPlurial, {count: Object.keys(question.props).length})}} <i class="fa fa-chevron-down"></i>
            </span>
            <span class="message-likes">
                <i v-if="!question.voted" class="fa fa-thumbs-o-up" v-on:click="likeQuestion()">&nbsp;</i>
                <i v-else class="fa fa-thumbs-up">&nbsp;</i>
                {{question.votes}}
            </span>
        </div>
    </div>
    <div v-if="showReplies" class="message-reply-section">
        <ul class="message-replies">
            <questionreplybox class="message-reply" v-for="(reply, index) in question.replies" v-bind:key="index" v-bind:reply="reply" v-bind:person="getPerson(index)" v-on:openPersonCard="openPersonCard($event)"></questionreplybox>
        </ul>
        <div class="message-reply-text">
            <img v-if="user.pictureUrl" class="message-reply-icon" v-bind:src="user.pictureUrl">
            <img v-else class="message-reply-icon" src="../../assets/icons/anonymous.svg">
            <input ref="replyInput" v-on:focus="replyFocus" v-model="replyText" v-on:keyup.enter="replyToQuestion" class="message-reply-text-box" maxlength="500" :placeholder="$t('str.EnterYourReplyHere')">
            <img v-on:click="replyToQuestion" class="message-reply-submit" src="../../assets/icons/enter.svg">
        </div>
    </div>
</li>
</template>

<script>

import Vue from 'vue';
import {EventBus, LeadBus} from '../../router/index';
import TimeUtils from '../../javascript-classes/utils/time';
import IdentifierUtils from '../../javascript-classes/utils/identifier';
import LanguageUtils from '../../javascript-classes/utils/language';
import NavigatorUtils from '../../javascript-classes/utils/navigator';
import QuestionReplyBox from '@/components/question/QuestionReplyBox';

// Constants
const ANONYMOUS_IMG = '/static/img/anonymous.svg';

export default {

    components: {
        questionreplybox: QuestionReplyBox
    },

    props: {
        question: {},
        peopleMap: {},
        person: {},
        user: {}
    },

    data() {
        return {
            showReplies: false,
            replyText: ''
        };
    },

    computed: {
        pictureUrl() {
            return this.person && this.person.pictureUrl && this.person.pictureUrl !== '' ? this.person.pictureUrl : ANONYMOUS_IMG;
        },

        getTimestamp() {
            return TimeUtils.formatFromNow(this.question.timestamp, (key) => { return this.$t('str.' + key); });
        },

        isPlurial() {
            return LanguageUtils.isPlural(Object.keys(this.question.props).length) ? 2 : 1;
        }
    },

    methods: {
        likeQuestion() {
            if (this.question && this.question.voted === false) {
                EventBus.$emit('likeQuestion', this.question);
            }
        },

        getPerson(index) {
            return index !== undefined && this.peopleMap && this.peopleMap.get ? this.peopleMap.get(this.question.replies[index].replyBy) : {};
        },

        replyToQuestion() {
            let reply = {
                comment: this.replyText.trim()
            };

            if (reply.comment !== '') {
                reply.questionId = this.question.id;
                EventBus.$emit('postQuestionProps', reply);
                this.replyText = '';
            }
        },

        viewReplies() {
            this.showReplies = true;

            setTimeout(() => {
                this.$refs.replyInput.focus();
            }, 50);
        },

        toggleReplies() {
            this.showReplies = !this.showReplies;

            if (this.showReplies) {
                let offsetHeight = this.$el.offsetTop; // Cache the value before the div gets expanded

                setTimeout(() => {
                    this.$emit("showChildAtPosition", offsetHeight);
                    
                    if (!NavigatorUtils.isMobile()) {
                        this.$refs.replyInput.focus();
                    }
                }, 50);
            }
        },

        openPersonCard(person) {
            if (person) {
                this.$emit('openPersonCard', person);
            } else {
                this.$emit('openPersonCard', this.person);
            }

            LeadBus.$emit('recordLead', {
                type: 'attendee-profile-card',
                data: {
                    profileCardOf: this.person.id
                }
            });
        },

        replyFocus() {
            if ((typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
                this.$refs.replyInput.scrollIntoView();
            }    
        }
    }
};

</script>

<style lang="scss">

.chat-item {
    list-style-type: none;
    align-items: flex-start;
    margin-bottom: 4px;
    display: block;
    margin-right: 2%;
    margin-left: 2%;

    .askerIcon {
        width: 36px;
        margin-top: 12px;
        border-style: none;
        cursor: pointer;
    }

    .message {
        background: #333;
        width: calc(100% - 10px);
        max-width: 560px;
        font-family: "Poppins", sans-serif;
        position: relative;
        display: table;
        min-height: 60px;

        img{
            margin-top: 0px;
        }

        .message-span{
            margin-left: 44px;
            margin-top: -40px;
            width: 75vw;

            .message-user-name {
                color: #d4451d;
                text-decoration: none;
                font-size: 13px;
                font-weight: 600;
                cursor: pointer;
            }

            .message-text {
                font-size: 1em;
                min-height: 18px;
                line-height: 1.2em;
                color: #f1f2f2;
                width: calc(100% - 20px);
                margin-bottom: 1px;
                margin-top: 3px;
                overflow-wrap: break-word;
            }
        }

        .message-bottom-menu{
            font-size: 0.75rem;
            color: grey;
            width: 100%;
            min-height: 20px;

            .message-timestamp{
                left: 8px;
                position: absolute;
            }

            .message-reply-button{
                left: 45px;
                position: absolute;
                cursor: pointer;
            }

            .message-comments {
                left: 40%;
                position: absolute;
                cursor: pointer;

                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

            .message-likes{
                position: absolute;
                right: 15px;
                cursor: pointer;
            }
        }
    }

    .message-reply-section{
        margin-left: 45px;
        background-color: rgb(0, 0, 0);
        display: block;

        .message-replies{
            padding: 0;
            list-style-type: none;
            margin-right: 10px;
        }
        .message-reply-text{
            border-style: solid;
            margin-top: 5px;
            margin-right: 10px;
            border: solid 2px #999;
            background-color: #fff;
            height: 30px;
            width: 75vw;
            box-sizing: inherit;

            .message-reply-icon{
                float: left;
                position: absolute;
                height: 30px;
                width: 30px;
            }
            .message-reply-text-box{
                width: calc(100% - 65px);
                margin-left: 27px;
                height: 22px;
                color: #000;
                background-color: #fff;
                font-size: 0.75em;
                line-height: 1.2em;
                padding-left: 10px;
                padding-top: 6px;
                border: none;
                resize: none;
                outline: none;
            }

            .message-reply-submit{
                width: 15px;
                position: absolute;
                margin-top: 8px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// QuestionBox.vue?a9805852